<div>
    <mat-toolbar color="primary">

        <!-- <button [color]="'primary'" *ngIf="showMenuButton" #btn (click)="onclick.emit();" onclick="this.blur()"
            mat-icon-button class="df aic cp br5" [ngClass]="{'onboarading-menu' : mc.hiddenToUser}">
            <mat-icon>{{mc.lockmenu && mc.isDesktop ? 'menu_open' : 'menu'}}</mat-icon>
        </button> -->

        @if (showMenuButton) {
            <app-menu-trigger [mc]="mc" [isOn]="'toolbar'"
            (onclick)="onclick.emit()"></app-menu-trigger>
        }
        


        <!-- Quick OR -->
        <!--<button mat-stroked-button color="primary" class="quick-or-button"
            (click)="openQuickOr()" [matTooltip]="'Crear OR rápida'">
            <mat-icon [filled]="true" style="min-width: 24px;" class="c_start">bolt</mat-icon>
            OR
        </button>-->


        <span class="example-spacer"></span>

        @if (companyCtxS.isImpersonating) {
          <div class="impersonating-banner">
            <mat-icon color="warn">visibility</mat-icon>
            <span style="color:black !important" [matTooltip]="'Modo solo lectura de empresa activado dentro de eina'">Viendo empresa #{{ companyCtxS.impersonatedCompanyId ?? '' }}</span>
            <button mat-stroked-button mat-button color="primary" (click)="leaveCompany()">
              <mat-icon>home</mat-icon>
              Volver a mi empresa
            </button>
          </div>
        }

        <div class="df aic" style="gap:5px">

            <!-- Change center (ONLY SUPER-USERS) -->
            <div eForm-section super-user [moreThan]="1250">
                <div [ngTemplateOutlet]="centerSelector"></div>
            </div>

            <!-- Tariff imports -->
            <!--<app-floating-import></app-floating-import>-->

            <!-- Check Sended Emails -->
            <!--<app-floating-emails></app-floating-emails>-->

            <!-- Review eina -->
            <!-- <button *ngIf="hasPendFeedback" mat-mini-fab color="primary" class="issues shake-new"
                [matTooltip]="'Danos tu opinión'" (click)="openFeedback()">
                <mat-icon [filled]="false">rate_review</mat-icon>
            </button> -->

            <!-- Help -->
            <!--<button [matTooltip]="'Inicio rápido'" class="help onboarading-help-toolbar"
                mat-mini-fab color="primary" (click)="onClickHelp()">
                <mat-icon [filled]="false">rocket</mat-icon>
            </button>

            <button [matTooltip]="'Documentación'"
                class="eina-documentation onboarading-eina-documentation-toolbar" mat-mini-fab color="primary"
                (click)="goDocumentation()">
                <mat-icon class="c_w">help_outline</mat-icon>
            </button>-->

            <!-- Notification -->
            <!-- <app-notifications [class_]="'mr-20'" [autoUpdate]="false" [getAll]="apiS.getNotifications.bind(apiS)"
                [readAll]="apiS.readAllNotifications.bind(apiS)" [setReaded]="apiS.setNotificationReaded.bind(apiS)"
                (onClickNotification)="mc.close(); notificationAction($event)">
            </app-notifications> -->


            <!-- Profile -->
            <button mat-icon-button [matMenuTriggerFor]="profileMenu" class="onboarding-profile">

                <div>
                    <app-circular-letter class="absolute-center" [checkIsMe]="false" [showTooltip]="false"
                        [user]="userS.user" [showFullName]="false"></app-circular-letter>
                    <mat-icon class="mini-icon-profile-time stop-icon" [filled]="true">
                    </mat-icon>
                    @if (responsiveS.w <= 500) {
                        <mat-icon class="mini-icon-profile-or or-icon" [filled]="true">
                            <span>build</span>
                        </mat-icon>
                    }
                </div>

                <ng-template #loadingProfile>
                    <app-skeleton class="absolute-center" [circle]="true" [transparency]="true" [height]="34"
                        [width]="34"></app-skeleton>
                </ng-template>
            </button>

            <mat-menu #profileMenu>

                <div class="toolbar-profile-menu">

                    <div class="df fdc aic jcc">
                        <app-circular-letter [imageUpload]="true" [showTooltip]="true" [checkIsMe]="false"
                            [showTooltip]="false" [medium]="true" [user]="userS.user" [showFullName]="false"
                            [showEditIcon]="true" (onUploadImage)="uploadImage($event)">
                        </app-circular-letter>
                        <p>{{greetingPhrase(userS.userName)}}</p>
                    </div>

                    <div eForm-section super-user [lessOr]="1250" class="df jcc">
                        <div [ngTemplateOutlet]="centerSelector"></div>
                    </div>

                    <div *ngIf="responsiveS.w <= 500">
                        <p></p>
                        <div eForm-wrapper>
                            <div class="wrapper-of-wrapper df fdc aic jcc">
                                <p class="tac">Trabajando en</p>
                                <!-- <app-working-or-timer [goAction]="true"></app-working-or-timer> -->
                            </div>
                        </div>
                        <p></p>
                    </div>

                    <!--<div eForm-wrapper>
                        <div class="wrapper-of-wrapper">-->
                            <!-- <app-signing-timer #signingTimerComponent></app-signing-timer> -->
                        <!--</div>
                        <p></p>

                        <button mat-menu-item (click)="routerS.goTo(v.myPresence)">
                            <mat-icon>calendar_clock</mat-icon>
                            Mi presencia
                        </button>
                    </div>-->

                    <p></p>

                    <div eForm-wrapper>
                        <button mat-menu-item (click)="goProfile()">
                            <mat-icon>person</mat-icon>
                            Perfil
                        </button>
                        <button class="help-on-profile" mat-menu-item
                            (click)="onClickHelp()">
                            <mat-icon>rocket</mat-icon>
                            Inicio rápido
                        </button>
                        <button class="eina-documentation-on-profile" mat-menu-item
                            (click)="goDocumentation()">
                            <mat-icon>help_outline</mat-icon>
                            Documentación
                        </button>
                        <button mat-menu-item (click)="sessionS.logOutDialog()">
                            <mat-icon>logout</mat-icon>
                            Cerrar sesión
                        </button>
                    </div>
                </div>

            </mat-menu>

        </div>
    </mat-toolbar>
</div>

<ng-template #centerSelector>
    <!-- <mat-form-field appearance="outline" class="small-form-field" prevent>
        <mat-label>Centro</mat-label>
        <mat-select [value]="einaDataS.company.userCenter?.id" (selectionChange)="onChangeCenter($event)">
            <mat-option *ngFor="let center of einaDataS.company.centers" [value]="center.id">
                {{ center.name }}
            </mat-option>
        </mat-select>
    </mat-form-field> -->
</ng-template>